import { Box, Card, Grid, Typography } from '@mui/material';
import React from 'react';

import { FaOptionIcon } from '@europrocurement/l2d-icons';
import { faUserTie } from '@fortawesome/sharp-regular-svg-icons';
import { useTheme } from '@mui/system';

export type GestionFermetureEtablissement = {
    custom_l2d: {
        siret: string;
    };
};

export type GestionFermetureEtablissementWidgetCallbackArgs = (
    gestionFermetureEtablissement: GestionFermetureEtablissement,
    index: number,
) => void;

export type GestionFermetureEtablissementWidgetType = {
    gestionFermetureEtablissement: GestionFermetureEtablissement;
    actions?: Array<{
        name: string;
        icon?: React.ReactNode | React.FunctionComponent;
        tooltip?: string;
        text?: string;
        onClick: GestionFermetureEtablissementWidgetCallbackArgs;
    }>;
    index?: number;
};

// exemple de style sur DisplayFile

export const GestionFermetureEtablissementWidget: React.FunctionComponent<GestionFermetureEtablissementWidgetType> =
    function ({
        gestionFermetureEtablissement,
        actions,
        index = -1,
    }: GestionFermetureEtablissementWidgetType) {
        const theme = useTheme();
        return (
            <Card sx={{ padding: '10px', cursor: 'pointer', margin: '15px 0' }}>
                <Grid
                    container
                    sx={{
                        marginLeft: '0px',
                    }}
                >
                    <Grid
                        item
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            width: '100%',
                            paddingLeft: '0px',
                        }}
                    >
                        <Box
                            display="flex"
                            flexDirection="row"
                            gap="10px"
                            sx={{
                                margin: '0 12px 0',
                            }}
                        >
                            <Box
                                data-testid="test-id-status-color-box"
                                sx={{
                                    margin: '0px',
                                    padding: '10px',
                                    borderRadius: '10px',
                                    fontSize: '25px',
                                    maxHeight: '65px',
                                    backgroundColor: 'rgba(66,221,245,0.2)',
                                }}
                            >
                                <FaOptionIcon
                                    data-testid="test-id-mimetype-icone"
                                    icon={faUserTie}
                                    color={theme.palette.primary.main}
                                    sx={{ fontSize: '33px' }}
                                />
                            </Box>
                            <Box sx={{ padding: '0 10px', minWidth: '150px' }}>
                                {gestionFermetureEtablissement.personneMorale?.autresEtablissements
                                    ?.descriptionEtablissement?.dateEffetFermeture && (
                                    <Typography
                                        variant="h6"
                                        sx={{ fontWeight: 'bold' }}
                                    >
                                        Date d&apos;effet :{' '}
                                        {new Date(
                                            gestionFermetureEtablissement.personneMorale
                                                ?.autresEtablissements?.descriptionEtablissement
                                                ?.dateEffetFermeture,
                                        ).toLocaleDateString('fr-FR')}
                                    </Typography>
                                )}
                                <Typography
                                    variant="h6"
                                    sx={{ fontWeight: 'bold' }}
                                >
                                    Siret : {gestionFermetureEtablissement.custom_l2d?.siret ?? ''}
                                </Typography>
                                <Typography variant="h6">
                                    Adresse :{' '}
                                    {`${gestionFermetureEtablissement.personneMorale?.autresEtablissements?.adresse?.voie ?? ''} - ${gestionFermetureEtablissement.personneMorale?.autresEtablissements?.adresse?.codePostal ?? ''} ${gestionFermetureEtablissement.personneMorale?.autresEtablissements?.adresse?.commune ?? ''}`.toUpperCase()}
                                </Typography>
                            </Box>
                        </Box>
                        <Box
                            display="flex"
                            flexDirection="row"
                            gap="10px"
                            sx={{
                                margin: '0 0 0 auto',
                            }}
                        >
                            {actions
                                ? actions.map((action, key) => (
                                      <Box
                                          title={action.tooltip}
                                          data-testid={`test-id-${key}-handleClick-button`}
                                          onClick={() =>
                                              action.onClick(gestionFermetureEtablissement, index)
                                          }
                                          role="button"
                                          key={action.name}
                                      >
                                          {action.icon || action.text}{' '}
                                      </Box>
                                  ))
                                : null}
                        </Box>
                    </Grid>
                </Grid>
            </Card>
        );
    };
